import React,{useEffect} from 'react'
import {TextField,Grid, Box,Button} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FreeRideFiveSchema } from '../../Utils/Validations'

const RideFormFive = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(FreeRideFiveSchema)
  })
  useEffect(() => {
    setValue("city_state", freeRideData.city_state || "")
    setValue("receiving_facility", freeRideData.receiving_facility || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setFreeRideData((prev) => ({ ...prev, city_state: data.city_state, receiving_facility: data.receiving_facility }))
    handleComplete()
  }
  return (
    <div>
        
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="city_state"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>City and State</label>
                <TextField fullWidth placeholder="City and State" {...field} error={errors.city_state} helperText={errors?.city_state?.message} />

              </>
            )}
          />
                
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="receiving_facility"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Receiving Facility Name</label>
                <TextField fullWidth placeholder='Receiving Facility Name'  {...field} error={errors.receiving_facility} helperText={errors?.receiving_facility?.message} />

              </>
            )}
          />
        
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default RideFormFive